import { render, staticRenderFns } from "./ProjectEditMain.vue?vue&type=template&id=484ccb37&"
import script from "./ProjectEditMain.vue?vue&type=script&lang=js&"
export * from "./ProjectEditMain.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEditMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports